module.exports = __webpack_public_path__ + "img/088.9bf6b76a.png";